import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { firstValueFrom } from 'rxjs'
import { CaseDetailComponent } from 'src/app/abacus/components/case-detail.component'

import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../abacus/services/flash-message.service'
import { AuthService } from '../../abacus/services/auth.service'
import { KeycloakService } from '../../abacus/services/keycloak.service'
import { ResourceService } from '../../abacus/services/resource.service'
import { userDefinition } from './user.definition'
import { oecdCountries } from '../../shared/data/oecd-countries'

@Component({
    templateUrl: './user-detail.component.html',
    standalone: true,
    imports: [
      CommonModule,
      RouterModule,
      FormsModule,
    ]
})
export class UserDetailComponent
  extends CaseDetailComponent
  implements OnInit
{
  definition: ResourceDefinition = userDefinition
  oecdCountries = oecdCountries
  profileForm = { organizationName: '', country: '', website: '' }
  private savedProfileForm = { organizationName: '', country: '', website: '' }
  savingProfile = false
  showOrgProfile = false
  editingProfile = false
  private flash: FlashMessageService

  constructor(
    breadcrumbService: BreadcrumbService,
    resourceService: ResourceService,
    flashMessageService: FlashMessageService,
    activatedRoute: ActivatedRoute,
    private customBreadcrumbService: BreadcrumbService,
    private authService: AuthService,
    private keycloakService: KeycloakService
  ) {
    super(
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
    this.flash = flashMessageService
  }

  async ngOnInit() {
    this.item = await firstValueFrom(this.authService.me())
    this.setBreadcrumbs()

    const perms = this.item?.role?.permissions?.map((p: any) => p.name) || []
    this.showOrgProfile = ['addOwnTransparencyReports', 'addTransparencyReports', 'submitTransparencyReports']
      .some(p => perms.includes(p))

    if (this.showOrgProfile && this.item?.transparencyReportProfile) {
      this.profileForm = {
        organizationName: this.item.transparencyReportProfile.organizationName || '',
        country: this.item.transparencyReportProfile.country || '',
        website: this.item.transparencyReportProfile.website || ''
      }
      this.savedProfileForm = { ...this.profileForm }
    }
  }

  setBreadcrumbs() {
    this.customBreadcrumbService.breadcrumbLinks.next([
      {
        label: 'My Profile'
      }
    ])
  }

  isAdmin(): boolean {
    return this.item?.role?.name === 'admin'
  }

  isTransparencyReportUser(): boolean {
    return this.item?.role?.name === 'transparencyReportUser'
  }

  getCountryLabel(code: string): string {
    return this.oecdCountries.find(c => c.value === code)?.label || code || '-'
  }

  cancelEditProfile(): void {
    this.profileForm = { ...this.savedProfileForm }
    this.editingProfile = false
  }

  saveProfile(): void {
    this.savingProfile = true
    this.authService.updateTransparencyReportProfile(this.profileForm).subscribe({
      next: async () => {
        await this.keycloakService.updateToken(-1)
        this.item = await firstValueFrom(this.authService.me())
        this.savedProfileForm = { ...this.profileForm }
        this.savingProfile = false
        this.editingProfile = false
        this.flash.success('Organization profile updated successfully.')
      },
      error: () => {
        this.savingProfile = false
        this.flash.error('Failed to update profile. Please try again.')
      }
    })
  }
}
